export const BD_GET_HEAVEYCOLLI_LISTING = "BD_GET_HEAVEYCOLLI_LISTING"
export const BD_GET_HEAVEYCOLLI_LISTING_SUCCESS = "BD_GET_HEAVEYCOLLI_LISTING_SUCCESS"
export const BD_GET_HEAVEYCOLLI_LISTING_FAILED = "BD_GET_HEAVEYCOLLI_LISTING_FAILED"
